<template>
  <div>
    <div class="grid grid-cols-4 gap-4">
      <div class="font-bold">{{ feature.properties.name }}</div>
      <div class="font-bold col-span-3">{{ feature.properties.description }}</div>
    </div>
    <div class="grid grid-cols-4 gap-4" v-for="obs in observations" :key="obs.component">
      <div>{{ obs.component}}</div>
      <div>{{ obs.value}} {{ obs.unit}}</div>
      <div>{{ obs.timestamp_from_epoch | epochToDate }}</div>
      <div>{{ obs.timestamp_to_epoch | epochToDate }}</div>
    </div>
    <button class="plotbtn" @click="onPlot">Plot data</button>
</div>
</template>

<script>
import Vue from 'vue'
import Notify from "@/helpers/notify";
import ObservationsService from "@/helpers/apiservices/observations/observations.service";
import { LButton } from "@/components/forms";
import router from "@/router"
import * as moment from "moment";

export default Vue.extend({
   components: {
    LButton 
  },
  props: {
    feature: {
      required: true,
      type: Object,
    },
    sensor:{type: Object}
  },
  data() {
    return {
      observations: [],
    };
  },
  mounted() {
    Notify.loadData(null, this.loadInitialData);
  },
  filters: {
    epochToDate: function (epoch) {
      return moment.unix(epoch).utc().format('YYYY-MM-DD HH:mm') + "Z";
    }
  },
  methods: {
    async loadInitialData () {
      this.observations = await ObservationsService.sensorobservations(
        {
          sensorid: this.feature.properties.id, 
          providerid: this.feature.properties.providerid
        });
    },
    onPlot() {
      var plotsensors = [];
      plotsensors.push(this.sensor);

      router.push({
          name: 'ObservationsPlot',
          params: {
              sensors: plotsensors
          }
      });
    }
  },
})
</script>

<style lang="scss" scoped>
  div{
    background-color:lightgray

  }
  .plotbtn{
    padding-top: 10px;
    padding-left: 10px;
    font-weight: bold;
    font-size: 12px;
    color: orangered;
  }
</style>>

</style>
